import React, { useState, useEffect, useCallback } from 'react';
import { Database, Search, List, Mail } from 'lucide-react';
import CategoriesTab from './CategoriesTab';
import ScrapeTab from './ScrapeTab';
import LeadsTab from './LeadsTab';
import EmailTab from './EmailTab';

const TABS = [
  { id: 'leads', label: 'Browse Leads', icon: Database },
  { id: 'scrape', label: 'Extract Data', icon: Search },
  { id: 'email', label: 'Email Extraction', icon: Mail },
  { id: 'categories', label: 'Categories', icon: List }
];

const TAB_STORAGE_KEY = 'canvassing_active_tab';

const CanvassingData = ({ userProfile }) => {
  const [activeTab, setActiveTab] = useState(() => {
    const saved = sessionStorage.getItem(TAB_STORAGE_KEY);
    return saved && TABS.some(t => t.id === saved) ? saved : 'leads';
  });

  const handleTabChange = useCallback((tabId) => {
    setActiveTab(tabId);
    sessionStorage.setItem(TAB_STORAGE_KEY, tabId);
  }, []);

  return (
    <div className="px-2 py-2 md:p-6 max-w-full">
      {/* Header */}
      <div className="mb-6">
        <div className="flex items-center space-x-3 mb-2">
          <Database size={28} className="text-pest-blue" />
          <h1 className="text-2xl font-bold text-gray-800">Canvassing Data</h1>
        </div>
        <p className="text-sm text-gray-500">
          Extract business data from Google Maps for pest control canvassing
        </p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="flex space-x-1 -mb-px">
          {TABS.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => handleTabChange(tab.id)}
                className={`flex items-center space-x-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                  isActive
                    ? 'border-pest-blue text-pest-blue'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <Icon size={16} />
                <span>{tab.label}</span>
              </button>
            );
          })}
        </nav>
      </div>

      {/* Tab Content */}
      {activeTab === 'categories' && <CategoriesTab />}
      {activeTab === 'scrape' && <ScrapeTab />}
      {activeTab === 'email' && <EmailTab />}
      {activeTab === 'leads' && <LeadsTab />}
    </div>
  );
};

export default CanvassingData;
